import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { EmailAuditModel } from './email-audit.model';

export const entityName = 'EmailAudit';
@Injectable({ providedIn: 'root' })
export class EmailAuditDataService extends EfaactDataService<EmailAuditModel> {
    mapItems(item: any): EmailAuditModel {
        const x = { ...item, id: item.Id };
        delete x.Id;
        return x;
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
